/**
 * Match React Router basename to how the dashboard is hosted:
 * - https://qtf.iniserve.com/admin/  → /admin
 * - https://example.com/qft/         → /qft
 * - site root                          → ''
 */
export function getRouterBasename() {
  const { pathname } = window.location;
  if (pathname === '/admin' || pathname.startsWith('/admin/')) return '/admin';
  if (pathname === '/qft' || pathname.startsWith('/qft/')) return '/qft';
  return process.env.PUBLIC_URL === '.' ? '' : (process.env.PUBLIC_URL || '');
}

/** Absolute URL for static files served by the API (APK, etc.) */
export function adminAssetUrl(relativePath) {
  const base = getRouterBasename();
  const path = relativePath.startsWith('/') ? relativePath : `/${relativePath}`;
  return `${base}${path}`;
}

export const ANDROID_APK_PUBLIC_PATH = '/android/QTF.apk';
